import React from "react";
import { Modal } from "antd";
import "./CancelledSuccessfully.scss";
import { useTranslation } from "react-i18next";

interface Props {
  open: boolean;
  onClose: () => void;
  isOpenGym?: boolean;
}

export const CancelledSuccessfully: React.FC<Props> = ({ open, onClose, isOpenGym }) => {
  const { t } = useTranslation();

  const title = t(isOpenGym ? "OpenGymCancelled" : "ClassCancelled");

  const description = t(isOpenGym ? "OpenGymCancelledDesc" : "ClassCancelledDesc");

  return (
    <Modal
      open={open}
      footer={null}
      centered
      onCancel={onClose}
      closable={false}
      className="booked-successfully-modal"
    >
      <div className="booked-successfully">
        <div className="booked-successfully__circle">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="46"
            height="46"
            viewBox="0 0 46 46"
            fill="none"
          >
            <g clip-path="url(#clip0_27743_17807)">
              <path
                d="M23 45.9999C35.7025 45.9999 45.9999 35.7025 45.9999 23C45.9999 10.2974 35.7025 0 23 0C10.2974 0 0 10.2974 0 23C0 35.7025 10.2974 45.9999 23 45.9999Z"
                fill="#32BC69"
              />
              <path
                d="M35.1187 10.8193L18.8593 27.0787L10.8809 19.1006L6.83008 23.1509L18.8593 35.1804L39.1696 14.8696L35.1187 10.8193Z"
                fill="#EBF0F3"
              />
            </g>
            <defs>
              <clipPath id="clip0_27743_17807">
                <rect width="46" height="46" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>

        <h2 className="booked-successfully__title">{title}</h2>
        <p className="booked-successfully__desc">{description}</p>

        <button className="booked-successfully__btn" onClick={onClose}>
          {t("Continue")}
        </button>
      </div>
    </Modal>
  );
};
